import '../../css/pages/landing.css';
import { initShell } from '../lib/shell';

initShell();

// Subtle parallax/entry animation on the hero, respecting reduced motion.
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (!prefersReducedMotion) {
  const content = document.querySelector<HTMLElement>('.landing__hero');
  const bg = document.querySelector<HTMLElement>('.landing__bg img');
  if (content && bg) {
    requestAnimationFrame(() => {
      content.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
      bg.style.transition = 'transform 1.2s ease';
      content.style.opacity = '0';
      content.style.transform = 'translateY(14px)';
      bg.style.transform = 'scale(1.06)';
      requestAnimationFrame(() => {
        content.style.opacity = '1';
        content.style.transform = 'translateY(0)';
        bg.style.transform = 'scale(1)';
      });
    });
  }
}
